var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"main-button-expand",class:{ 'main-button-expand_expanded': _vm.expanded },on:{"click":function($event){return _vm.$emit('update:expanded', !_vm.expanded)}}},[_vm._v(" "+_vm._s(_vm.currentButtonText)+" "),_c('span',{staticClass:"main-button-expand__arrow"})])
}
var staticRenderFns = []

export { render, staticRenderFns }